module.exports = __webpack_public_path__ + "img/vende_tu_auto_paso1_mobile.6bb89707.png";